/*
 * Authors: mariushirjanu, Jakub
 * Created: 14/01/2022
 */

import { Injectable } from '@angular/core';
import { HttpDataService } from '../../../shared/http/http-data.service';

export interface ICatalogGuideCodePart {
  webshopId:number;
  countryId:number;
  part:string;
  buyingGuideCode:string;
}

@Injectable()
export class WebshopGuideDataService {
  constructor(private httpDataService:HttpDataService) {
    /***/
  }

  public getCodeParts(webshopId:number, countryId:number, code:string):Promise<ICatalogGuideCodePart[]> {
    return this.httpDataService.doGET(
      `rest/buyingguide/${webshopId}/${countryId}/parts/${code}`,
      undefined,
      undefined,
      'Error loading buying guide parts'
    );
  }

  public saveCodeParts(webshopId:number, countryId:number, code:string, parts:string[]):Promise<ICatalogGuideCodePart[]> {
    return this.httpDataService.doPOST(
      `rest/buyingguide/${webshopId}/${countryId}/parts/${code}`,
      undefined,
      parts,
      'Saving buying guide parts',
      'Error saving buying guide parts'
    );
  }
}